import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter);





function loggedInRedirectDashboard(to, from, next) {
  if (localStorage.token) {
    next('/');
  } else {
    next();
  }
}

function isLoggedIn(to, from, next) {
  if (localStorage.token) {
    next();
  } else {
    next('/login');
  }
}










  const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/auth/login.vue'),
    beforeEnter: loggedInRedirectDashboard,
  },



  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: isLoggedIn,
  },

  {
    path: '/petaInvestasi',
    name: 'petaInvestasi',
    component: () => import('../views/investasi/petaInvestasi.vue'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/potensiInvestasi',
    name: 'potensiInvestasi',
    component: () => import('../views/investasi/potensiInvestasi.vue'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/faq',
    name: 'faq',
    component: () => import('../views/faq.vue'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    beforeEnter: isLoggedIn,
  },


]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

export default router
